// Popup Modal Manager: Listens to "popup", "popoff", emits "popclose"
// Might want to change this to Event Manager
// And handle the router listener from App.vue

<template>
	<div ref="popContainer" />
</template>

<script>
import { m } from "@/utils/utils";
import * as Utils from "@/utils/utils";
import CfgApp from "@/assets/cfg/CfgApp"
import Vue from "vue";
import PopWin from '@/components/common/PopWin.vue';
import PopDoor from '@/components/common/PopDoor.vue';
import UniInput from '@/components/common/UniInput.vue';
import { eventBus } from '@/main';

export default {
	data() {
		return {
			popStack: [],
			popCountMax: 10,
			popTypes: {
				"door": PopDoor,
				"win": PopWin,
				"input": UniInput,
			},
			checkString: "",
		}
	},
	methods: {
		// Popup Listener Handler: Create Popup on Top
		handlePopup(payload) {
			if (this.popStack.length < this.popCountMax) {
				// m("handle popup", this.$store);

				Utils.blur();

				const popType = this.popTypes[payload.popType] || PopWin;
				var ComponentClass = Vue.extend(popType);
				var instance = new ComponentClass({
					store: this.$store,
					propsData: { 
						popData: {...payload, popIdx:this.popStack.length}
					}
				});
				this.popStack.push(instance);
				instance.$mount();
				const el = instance.$el;
				el.style.position = "absolute";
				el.style.top = "0px";
				el.style.left = "0px";
				el.style.zIndex = this.popStack.length + 200;
				this.$refs.popContainer.appendChild(el);
			} else {
				// m("popup max: " + this.popStack.length);
			}

		},

		// Popoff Listener Handler: Destroy Top Popup
		handlePopoff() {
			// m("handle popoff");
			if (this.popStack.length > 0) {
				let instance = this.popStack.pop();
				this.$refs.popContainer.removeChild(instance.$el);
				instance.$destroy();
			}
		},
		
		// Popoff Listener Handler: Destroy All Popups
		handlePopoffAll() {
			m("pop mgr handle popoff all", this.popStack.length);

			while (this.popStack.length>0) {
				let instance = this.popStack.pop();
				try {
					this.$refs.popContainer.removeChild(instance.$el);
					instance.$destroy();
				} catch (err) {
					m("pop remove error:", err);
				}
			}

		},
		
		// Send "close" to Top Popup Instance
		goPopClose() {
			// m("mgr pop close " + (this.popStack.length -1 ));
			eventBus.$emit('popcloseidx', this.popStack.length - 1);
		},

		// Key listener
		handleKey(evt) {

			// Escape = close popup
			if (evt.key.indexOf('Esc')===0) {
				// evt.stopImmediatePropagation();
				this.goPopClose();
			}		

			// Check hotWord
			this.checkString = this.checkString.concat(evt.key).slice(-CfgApp.toggleRole.hotWord.length); // Last 
			if (this.checkString == CfgApp.toggleRole.hotWord) {
				this.toggleRole();
			}
			
		},
		toggleRole() {
			m("mgr toggle role");
			this.$store.dispatch("app/toggleRole");
		},
		goTest(evt) {
			alert("test: " + evt.keyCode);
		}
	},
	created() {
		m("pop mgr created", CfgApp.toggleRole.hotWord);
		eventBus.$on('popup', this.handlePopup);
		eventBus.$on('popoff', this.handlePopoff);
		eventBus.$on('popoffall', this.handlePopoffAll);
		eventBus.$on('popclose', this.goPopClose);
		eventBus.$on('togglerole', this.toggleRole);
		window.addEventListener("keydown", this.handleKey);
	},
	beforeDestroy() {
		eventBus.$off('popup', this.handlePopup);
		eventBus.$off('popoff', this.handlePopoff);
		eventBus.$off('popoffall', this.handlePopoffAll);
		eventBus.$off('popclose', this.goPopClose);
		eventBus.$off('togglerole', this.toggleRole);
		window.removeEventListener("keydown", this.handleKey);
	},

}
</script>

<style scoped>
</style>
